export const hideLoader = () => {
  const ele = document.querySelectorAll('#loader');
  if (ele && ele.length > 0) {
    ele.forEach((item) => {
      const loader = item;
      loader.style.display = 'none';
    });
  }
  /** work around for existing loader to hide  - should be removed once plain loader integrated in all pages  - commenting out since it is no longer needed */
  /* const existingLoaderEle = document.querySelector('[aria-label="loader overlay"], :not(#loader)');
  if(existingLoaderEle) {
    hideLoaderAction(store.dispatch);
  } */
};

export const showLoader = () => {
  try {
    const ele = document.getElementById('loader');
    if (ele) {
      if (ele.style.display === 'block') {
        // Performance improve and avoids calling focusTrap.activate() twice;
        return;
      }
      ele.style.display = 'block';
    } else {
      const injectLoader = document.createElement('div');
      injectLoader.setAttribute('id', 'loader');
      injectLoader.setAttribute('aria-label', 'loader overlay');
      injectLoader.setAttribute('class', 'loaderOverlay');
      injectLoader.innerHTML = '<div tabindex="0" aria-label="loader animation" class="loader"></div>';
      document.body.appendChild(injectLoader);
    }
  } catch (e) {
    console.log(e);
  }
};

export const hideHTMLLoader = () => {
  const ele = document.getElementById('loader');
  if (ele) {
    ele.style.display = 'none';
  }
};
